import { AllocationRuleDTO } from "./allocationRuleDTO";

export class AllocationProtocolDTO {

    public id!: number;
    public sequenceNo!: number;
    public keyFieldReferences!: string;
    public allocationFieldReference!: string;
    public allocationFieldMethod!: number;
    public creditFieldReference!: string;
    public debitFieldReference!: string;
    public allocationRules!: AllocationRuleDTO[];

    constructor(){
        this.allocationRules = new Array();
    }
}